module.exports = __webpack_public_path__ + "8d208efd24bccab939125638fd2929b2.svg";